import { useState, useRef, useEffect } from "react";
import { X, CreditCard, Check, Edit } from "lucide-react";

const ServicePaymentModal = ({
  service,
  isOpen,
  onClose,
  onUpdate,
  formatCurrency,
  defaultTab = "payment",
}) => {
  const [activeTab, setActiveTab] = useState("payment");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [invoice, setInvoice] = useState("");
  const [description, setDescription] = useState("");
  const [paymentDate, setPaymentDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [isLoading, setIsLoading] = useState(false);

  // Edit service fields
  const [editPrice, setEditPrice] = useState("");
  const [editReason, setEditReason] = useState("");
  const [editDescription, setEditDescription] = useState("");
  const [editDate, setEditDate] = useState("");

  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setActiveTab(defaultTab);
    }
  }, [isOpen, defaultTab]);

  useEffect(() => {
    if (service && isOpen) {
      setEditPrice(service.price.toString());
      setEditReason(service.reason);
      setEditDescription(service.description || "");
      setEditDate(
        service.date ? new Date(service.date).toISOString().split("T")[0] : ""
      );
    }
  }, [service, isOpen]);

  if (!isOpen || !service) return null;

  const handleAmountChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, "");
    const numValue = parseInt(value) || 0;

    if (numValue > service.balance) {
      alert("El monto supera el balance pendiente");
      return;
    }
    setPaymentAmount(value);
  };

  const handleEditPriceChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, "");
    setEditPrice(value);
  };

  const formatInputCurrency = (value) => {
    if (!value) return "";
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleAddPayment = async () => {
    if (!paymentAmount || paymentAmount === "0") {
      alert("Por favor ingrese un monto válido");
      return;
    }

    setIsLoading(true);

    const newPayment = {
      amount: parseInt(paymentAmount),
      invoice: invoice,
      date: paymentDate,
      description: description,
      id: `payment_${Date.now()}`,
    };

    const updatedService = {
      ...service,
      payments: [...(service.payments || []), newPayment],
      balance: service.balance - parseInt(paymentAmount),
      hasBeenPaid: service.balance - parseInt(paymentAmount) === 0,
    };

    await onUpdate(updatedService);

    // Reset form
    setPaymentAmount("");
    setInvoice("");
    setDescription("");
    setPaymentDate(new Date().toISOString().split("T")[0]);
    setIsLoading(false);
    onClose();
  };

  const handleMarkAsPaid = async () => {
    setIsLoading(true);

    const fullPayment = {
      amount: service.balance,
      invoice: invoice,
      date: paymentDate,
      description: description || "Pago completo",
      id: `payment_${Date.now()}`,
    };

    const updatedService = {
      ...service,
      payments: [...(service.payments || []), fullPayment],
      balance: 0,
      hasBeenPaid: true,
    };

    await onUpdate(updatedService);
    setIsLoading(false);
    onClose();
  };

  const handleEditService = async () => {
    if (!editPrice || editPrice === "0" || !editReason) {
      alert("Por favor complete los campos requeridos");
      return;
    }

    setIsLoading(true);

    const totalPaid = (service.payments || []).reduce(
      (sum, p) => sum + p.amount,
      0
    );
    const newPrice = parseInt(editPrice);
    const newBalance = newPrice - totalPaid;

    const updatedService = {
      ...service,
      price: newPrice,
      reason: editReason,
      description: editDescription,
      date: editDate,
      balance: newBalance,
      hasBeenPaid: newBalance === 0,
    };

    await onUpdate(updatedService);
    setIsLoading(false);
    onClose();
  };

  const remainingBalance = service.balance - (parseInt(paymentAmount) || 0);

  return (
    // <div className="fixed inset-0 z-50 flex items-center justify-center">
    //   <div
    //     className="absolute inset-0 bg-black opacity-50"
    //     onClick={onClose}
    //   ></div>

    //   <div
    //     ref={modalRef}
    //     className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto"
    //   >
    //     {/* Header */}
    //     <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between rounded-t-xl">
    //       <div>
    //         <h2 className="text-xl font-bold text-gray-900">
    //           Gestionar Servicio
    //         </h2>
    //         <p className="text-sm text-gray-600 mt-1">
    //           {service.patientName} - {service.reason}
    //         </p>
    //       </div>
    //       <button
    //         onClick={onClose}
    //         className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
    //       >
    //         <X className="w-5 h-5 text-gray-500" />
    //       </button>
    //     </div>

    //     {/* Tabs */}
    //     <div className="border-b border-gray-200 px-6">
    //       <div className="flex gap-4">
    //         <button
    //           onClick={() => setActiveTab("payment")}
    //           className={`py-3 px-4 font-medium text-sm border-b-2 transition-colors ${
    //             activeTab === "payment"
    //               ? "border-blue-600 text-blue-600"
    //               : "border-transparent text-gray-500 hover:text-gray-700"
    //           }`}
    //         >
    //           <div className="flex items-center gap-2">
    //             <CreditCard className="w-4 h-4" />
    //             Registrar Pago
    //           </div>
    //         </button>
    //         <button
    //           onClick={() => setActiveTab("markPaid")}
    //           className={`py-3 px-4 font-medium text-sm border-b-2 transition-colors ${
    //             activeTab === "markPaid"
    //               ? "border-blue-600 text-blue-600"
    //               : "border-transparent text-gray-500 hover:text-gray-700"
    //           }`}
    //         >
    //           <div className="flex items-center gap-2">
    //             <Check className="w-4 h-4" />
    //             Marcar Pagado
    //           </div>
    //         </button>
    //         <button
    //           onClick={() => setActiveTab("edit")}
    //           className={`py-3 px-4 font-medium text-sm border-b-2 transition-colors ${
    //             activeTab === "edit"
    //               ? "border-blue-600 text-blue-600"
    //               : "border-transparent text-gray-500 hover:text-gray-700"
    //           }`}
    //         >
    //           <div className="flex items-center gap-2">
    //             <Edit className="w-4 h-4" />
    //             Editar Servicio
    //           </div>
    //         </button>
    //       </div>
    //     </div>

    //     {/* Content */}
    //     <div className="p-6">
    //       {/* Service Summary */}
    //       <div className="bg-gray-50 rounded-lg p-4 mb-6">
    //         <div className="grid grid-cols-2 gap-4 text-sm">
    //           <div>
    //             <span className="text-gray-600">Precio Total:</span>
    //             <span className="ml-2 font-bold text-gray-900">
    //               {formatCurrency(service.price)}
    //             </span>
    //           </div>
    //           <div>
    //             <span className="text-gray-600">Saldo Pendiente:</span>
    //             <span className="ml-2 font-bold text-red-600">
    //               {formatCurrency(service.balance)}
    //             </span>
    //           </div>
    //         </div>
    //       </div>

    //       {/* Add Payment Tab */}
    //       {activeTab === "payment" && (
    //         <div className="space-y-4">
    //           <div>
    //             <label className="block text-sm font-medium text-gray-700 mb-2">
    //               Monto del Pago <span className="text-red-500">*</span>
    //             </label>
    //             <input
    //               type="text"
    //               value={formatInputCurrency(paymentAmount)}
    //               onChange={handleAmountChange}
    //               placeholder="0"
    //               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //             />
    //             {paymentAmount && (
    //               <p className="text-sm text-gray-600 mt-1">
    //                 Saldo restante: {formatCurrency(remainingBalance)}
    //               </p>
    //             )}
    //           </div>

    //           <div>
    //             <label className="block text-sm font-medium text-gray-700 mb-2">
    //               Número de Factura
    //             </label>
    //             <input
    //               type="text"
    //               value={invoice}
    //               onChange={(e) => setInvoice(e.target.value)}
    //               placeholder="001-001-0000001"
    //               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //             />
    //           </div>

    //           <div>
    //             <label className="block text-sm font-medium text-gray-700 mb-2">
    //               Descripción
    //             </label>
    //             <textarea
    //               value={description}
    //               onChange={(e) => setDescription(e.target.value)}
    //               placeholder="Notas adicionales sobre el pago..."
    //               rows={3}
    //               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //             />
    //           </div>

    //           <div>
    //             <label className="block text-sm font-medium text-gray-700 mb-2">
    //               Fecha del Pago
    //             </label>
    //             <input
    //               type="date"
    //               value={paymentDate}
    //               onChange={(e) => setPaymentDate(e.target.value)}
    //               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //             />
    //           </div>

    //           <button
    //             onClick={handleAddPayment}
    //             disabled={isLoading || !paymentAmount || paymentAmount === "0"}
    //             className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 text-white font-medium py-3 rounded-lg transition-colors"
    //           >
    //             {isLoading ? "Guardando..." : "Registrar Pago"}
    //           </button>
    //         </div>
    //       )}

    //       {/* Mark as Paid Tab */}
    //       {activeTab === "markPaid" && (
    //         <div className="space-y-4">
    //           <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
    //             <p className="text-sm text-blue-800">
    //               Esto registrará un pago por el monto completo pendiente de{" "}
    //               <span className="font-bold">
    //                 {formatCurrency(service.balance)}
    //               </span>{" "}
    //               y marcará el servicio como totalmente pagado.
    //             </p>
    //           </div>

    //           <div>
    //             <label className="block text-sm font-medium text-gray-700 mb-2">
    //               Número de Factura
    //             </label>
    //             <input
    //               type="text"
    //               value={invoice}
    //               onChange={(e) => setInvoice(e.target.value)}
    //               placeholder="001-001-0000001"
    //               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //             />
    //           </div>

    //           <div>
    //             <label className="block text-sm font-medium text-gray-700 mb-2">
    //               Descripción
    //             </label>
    //             <textarea
    //               value={description}
    //               onChange={(e) => setDescription(e.target.value)}
    //               placeholder="Pago completo del servicio..."
    //               rows={3}
    //               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //             />
    //           </div>

    //           <div>
    //             <label className="block text-sm font-medium text-gray-700 mb-2">
    //               Fecha del Pago
    //             </label>
    //             <input
    //               type="date"
    //               value={paymentDate}
    //               onChange={(e) => setPaymentDate(e.target.value)}
    //               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //             />
    //           </div>

    //           <button
    //             onClick={handleMarkAsPaid}
    //             disabled={isLoading}
    //             className="w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-300 text-white font-medium py-3 rounded-lg transition-colors"
    //           >
    //             {isLoading
    //               ? "Guardando..."
    //               : "Marcar como Pagado Completamente"}
    //           </button>
    //         </div>
    //       )}

    //       {/* Edit Service Tab */}
    //       {activeTab === "edit" && (
    //         <div className="space-y-4">
    //           <div>
    //             <label className="block text-sm font-medium text-gray-700 mb-2">
    //               Nombre del Servicio <span className="text-red-500">*</span>
    //             </label>
    //             <input
    //               type="text"
    //               value={editReason}
    //               onChange={(e) => setEditReason(e.target.value)}
    //               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //             />
    //           </div>

    //           <div>
    //             <label className="block text-sm font-medium text-gray-700 mb-2">
    //               Precio Total <span className="text-red-500">*</span>
    //             </label>
    //             <input
    //               type="text"
    //               value={formatInputCurrency(editPrice)}
    //               onChange={handleEditPriceChange}
    //               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //             />
    //             {editPrice && (
    //               <p className="text-sm text-gray-600 mt-1">
    //                 Nuevo saldo:{" "}
    //                 {formatCurrency(
    //                   parseInt(editPrice) -
    //                     (service.payments || []).reduce(
    //                       (sum, p) => sum + p.amount,
    //                       0
    //                     )
    //                 )}
    //               </p>
    //             )}
    //           </div>

    //           <div>
    //             <label className="block text-sm font-medium text-gray-700 mb-2">
    //               Descripción
    //             </label>
    //             <textarea
    //               value={editDescription}
    //               onChange={(e) => setEditDescription(e.target.value)}
    //               rows={3}
    //               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //             />
    //           </div>

    //           <div>
    //             <label className="block text-sm font-medium text-gray-700 mb-2">
    //               Fecha del Servicio
    //             </label>
    //             <input
    //               type="date"
    //               value={editDate}
    //               onChange={(e) => setEditDate(e.target.value)}
    //               className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    //             />
    //           </div>

    //           <button
    //             onClick={handleEditService}
    //             disabled={
    //               isLoading || !editPrice || editPrice === "0" || !editReason
    //             }
    //             className="w-full bg-orange-600 hover:bg-orange-700 disabled:bg-gray-300 text-white font-medium py-3 rounded-lg transition-colors"
    //           >
    //             {isLoading ? "Guardando..." : "Actualizar Servicio"}
    //           </button>
    //         </div>
    //       )}
    //     </div>
    //   </div>
    // </div>

    <div className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4">
      <div
        className="absolute inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>

      <div
        ref={modalRef}
        className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[95vh] sm:max-h-[90vh] overflow-y-auto"
      >
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-4 sm:px-6 py-3 sm:py-4 rounded-t-xl z-10">
          <div className="flex items-start justify-between gap-3">
            <div className="flex-1 min-w-0">
              <h2 className="text-lg sm:text-xl font-bold text-gray-900 truncate">
                Gestionar Servicio
              </h2>
              <p className="text-xs sm:text-sm text-gray-600 mt-1 truncate">
                {service.patientName} - {service.reason}
              </p>
            </div>
            <button
              onClick={onClose}
              className="flex-shrink-0 p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>
        </div>

        {/* Tabs */}
        <div className="border-b border-gray-200 px-2 sm:px-6 overflow-x-auto">
          <div className="flex gap-1 sm:gap-4 min-w-max">
            <button
              onClick={() => setActiveTab("payment")}
              className={`py-3 px-2 sm:px-4 font-medium text-xs sm:text-sm border-b-2 transition-colors whitespace-nowrap ${
                activeTab === "payment"
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              <div className="flex items-center gap-1 sm:gap-2">
                <CreditCard className="w-3 h-3 sm:w-4 sm:h-4" />
                <span className="hidden xs:inline">Registrar Pago</span>
                <span className="xs:hidden">Pago</span>
              </div>
            </button>
            <button
              onClick={() => setActiveTab("markPaid")}
              className={`py-3 px-2 sm:px-4 font-medium text-xs sm:text-sm border-b-2 transition-colors whitespace-nowrap ${
                activeTab === "markPaid"
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              <div className="flex items-center gap-1 sm:gap-2">
                <Check className="w-3 h-3 sm:w-4 sm:h-4" />
                <span className="hidden xs:inline">Marcar Pagado</span>
                <span className="xs:hidden">Pagado</span>
              </div>
            </button>
            <button
              onClick={() => setActiveTab("edit")}
              className={`py-3 px-2 sm:px-4 font-medium text-xs sm:text-sm border-b-2 transition-colors whitespace-nowrap ${
                activeTab === "edit"
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              <div className="flex items-center gap-1 sm:gap-2">
                <Edit className="w-3 h-3 sm:w-4 sm:h-4" />
                <span className="hidden xs:inline">Editar Servicio</span>
                <span className="xs:hidden">Editar</span>
              </div>
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-4 sm:p-6">
          {/* Service Summary */}
          <div className="bg-gray-50 rounded-lg p-3 sm:p-4 mb-4 sm:mb-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 text-xs sm:text-sm">
              <div className="flex justify-between sm:block">
                <span className="text-gray-600">Precio Total:</span>
                <span className="ml-2 font-bold text-gray-900">
                  {formatCurrency(service.price)}
                </span>
              </div>
              <div className="flex justify-between sm:block">
                <span className="text-gray-600">Saldo Pendiente:</span>
                <span className="ml-2 font-bold text-red-600">
                  {formatCurrency(service.balance)}
                </span>
              </div>
            </div>
          </div>

          {/* Add Payment Tab */}
          {activeTab === "payment" && (
            <div className="space-y-3 sm:space-y-4">
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Monto del Pago <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={formatInputCurrency(paymentAmount)}
                  onChange={handleAmountChange}
                  placeholder="0"
                  className="w-full px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                {paymentAmount && (
                  <p className="text-xs sm:text-sm text-gray-600 mt-1">
                    Saldo restante: {formatCurrency(remainingBalance)}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Número de Factura
                </label>
                <input
                  type="text"
                  value={invoice}
                  onChange={(e) => setInvoice(e.target.value)}
                  placeholder="001-001-0000001"
                  className="w-full px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Descripción
                </label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Notas adicionales sobre el pago..."
                  rows={3}
                  className="w-full px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Fecha del Pago
                </label>
                <input
                  type="date"
                  value={paymentDate}
                  onChange={(e) => setPaymentDate(e.target.value)}
                  className="w-full px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <button
                onClick={handleAddPayment}
                disabled={isLoading || !paymentAmount || paymentAmount === "0"}
                className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 text-white font-medium py-2.5 sm:py-3 rounded-lg transition-colors text-sm sm:text-base"
              >
                {isLoading ? "Guardando..." : "Registrar Pago"}
              </button>
            </div>
          )}

          {/* Mark as Paid Tab */}
          {activeTab === "markPaid" && (
            <div className="space-y-3 sm:space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 sm:p-4 mb-3 sm:mb-4">
                <p className="text-xs sm:text-sm text-blue-800">
                  Esto registrará un pago por el monto completo pendiente de{" "}
                  <span className="font-bold">
                    {formatCurrency(service.balance)}
                  </span>{" "}
                  y marcará el servicio como totalmente pagado.
                </p>
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Número de Factura
                </label>
                <input
                  type="text"
                  value={invoice}
                  onChange={(e) => setInvoice(e.target.value)}
                  placeholder="001-001-0000001"
                  className="w-full px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Descripción
                </label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Pago completo del servicio..."
                  rows={3}
                  className="w-full px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Fecha del Pago
                </label>
                <input
                  type="date"
                  value={paymentDate}
                  onChange={(e) => setPaymentDate(e.target.value)}
                  className="w-full px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <button
                onClick={handleMarkAsPaid}
                disabled={isLoading}
                className="w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-300 text-white font-medium py-2.5 sm:py-3 rounded-lg transition-colors text-sm sm:text-base"
              >
                {isLoading
                  ? "Guardando..."
                  : "Marcar como Pagado Completamente"}
              </button>
            </div>
          )}

          {/* Edit Service Tab */}
          {activeTab === "edit" && (
            <div className="space-y-3 sm:space-y-4">
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Nombre del Servicio <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={editReason}
                  onChange={(e) => setEditReason(e.target.value)}
                  className="w-full px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Precio Total <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={formatInputCurrency(editPrice)}
                  onChange={handleEditPriceChange}
                  className="w-full px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                {editPrice && (
                  <p className="text-xs sm:text-sm text-gray-600 mt-1">
                    Nuevo saldo:{" "}
                    {formatCurrency(
                      parseInt(editPrice) -
                        (service.payments || []).reduce(
                          (sum, p) => sum + p.amount,
                          0
                        )
                    )}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Descripción
                </label>
                <textarea
                  value={editDescription}
                  onChange={(e) => setEditDescription(e.target.value)}
                  rows={3}
                  className="w-full px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">
                  Fecha del Servicio
                </label>
                <input
                  type="date"
                  value={editDate}
                  onChange={(e) => setEditDate(e.target.value)}
                  className="w-full px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <button
                onClick={handleEditService}
                disabled={
                  isLoading || !editPrice || editPrice === "0" || !editReason
                }
                className="w-full bg-orange-600 hover:bg-orange-700 disabled:bg-gray-300 text-white font-medium py-2.5 sm:py-3 rounded-lg transition-colors text-sm sm:text-base"
              >
                {isLoading ? "Guardando..." : "Actualizar Servicio"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServicePaymentModal;
